// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/fleet/Fleet"),
  orderPrio: 40,
  iconType: "car",
  name: "fleet"
}: AppType)
